import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, tap, finalize } from 'rxjs';
import { SpinnerService } from '@services/spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  private readonly excludedUrls = [
    '/assets',
    '.json',
    '/report/download',
    '/auth/login',
    '/auth/refresh-token',
    '/auth/2fa/validate',
    '/auth/2fa/activate'
  ];

  constructor(private spinnerService: SpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url;
    const skip = this.shouldBypass(url);
    const start = performance.now();

    if (!skip) this.spinnerService.requestStarted();

    return next.handle(req).pipe(
      tap({
        next: () => this.logPerformance(url, start),
        error: () => this.logPerformance(url, start, true)
      }),
      finalize(() => {
        if (!skip) this.spinnerService.requestEnded();
      })
    );
  }

  private shouldBypass(url: string): boolean {
    return this.excludedUrls.some(excluded => url.includes(excluded));
  }

  private logPerformance(url: string, startTime: number, isError = false): void {
    const elapsed = performance.now() - startTime;
    const time = `${elapsed.toFixed(0)}ms`;
    const status = isError ? '❌ ERROR' : '✅ OK';

    console.log(`[HTTP][${status}] ${url} – ${time}`);
    if (!isError && elapsed > 5000) {
      console.warn(`[HTTP][⚠️ LENTO] ${url} superó los 5s (${time})`);
    }
  }
}
